/**
 * This file is part of the JS Money library
 *
 * Copyright (c) 2014 David Kalosi
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

module.exports = require('./money');



//////////////////
// WEBPACK FOOTER
// ./node_modules/js-money/lib/index.js
// module id = 83
// module chunks = 0 1 2